import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Splide, SplideSlide } from "@splidejs/react-splide";

import Card from "./Card";
import Arrow from "./Arrow";
import Empty from "../../../../components/Empty/Empty";
import { filterCardTag } from "./utils/filterTag";
import { useTranslation } from "react-i18next";

const SwiperCard = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`profile.${key}`);

  const {
    setOpenCardSetting,
    setCardInformation,
    cardNumber,
    setData,
    data,
    noSettings, //沒有設定銀行卡
  } = props;

  const swiperRef = useRef();

  const memberData = useSelector((state) => state.isMemberInfo);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof setData === "function") {
      setData({
        [`bank_name`]: memberData?.[`bank_name`],
        [`bank_acc`]: memberData?.[`bank_acc`],
        [`bank_code`]: memberData?.[`bank_code`],
        [`bank_num`]: memberData?.[`bank_num`],
      });
    }
  }, []);

  return (
    <Splide
      ref={swiperRef}
      className="relative !overflow-visible md:w-[80%]"
      onSlideChange={(swiper) => {
        const card = filterCardTag(swiper.activeIndex);
        setData({
          ...data,
          [`bank_name`]: memberData?.[`bank_name${card}`],
          [`bank_acc`]: memberData?.[`bank_acc${card}`],
          [`bank_code`]: memberData?.[`bank_code${card}`],
          [`bank_num`]: memberData?.[`bank_num${card}`],
        });
      }}
    >
      {cardNumber.map((card, index) => {
        return !memberData?.[`bank_num${card}`] ? (
          <SplideSlide key={index}>
            <section
              className="mt-[40px]"
              onClick={() => {
                if (location.pathname !== "/profile") {
                  navigate("/profile");
                  return;
                }
                setOpenCardSetting(true);
              }}
            >
              <Empty />
              <p className="underline text-center text-light-text">
                {i18n("card.addCard")}
              </p>
            </section>
          </SplideSlide>
        ) : (
          <SplideSlide key={index}>
            <Card
              noSettings={noSettings}
              cardNumber={card}
              setCardInformation={setCardInformation}
              setOpenCardSetting={setOpenCardSetting}
            />
          </SplideSlide>
        );
      })}
      <Arrow
        setCardInformation={setCardInformation}
        setOpenCardSetting={setOpenCardSetting}
        swiperRef={swiperRef}
      />
    </Splide>
  );
});

export default SwiperCard;
